// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"AppCheckbox_checkboxContainer__jZ5Wq","checkmark":"AppCheckbox_checkmark__9c3Di","darkCheckmark":"AppCheckbox_darkCheckmark__fG8kV"};